import * as React from 'react'
import styled from 'styled-components'

type InputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  label?: string
  errorMessage?: string
  hasError?: boolean
}

const StyledInput = styled.input<{
  hasError?: boolean
  themeColor?: string
}>`
  font-size: ${(props) => props.theme.defaultFontSize};
  font-family: ${(props) => props.theme.fontFamily};
  box-sizing: border-box;

  height: 22px;

  padding-bottom: 4px;

  border: 0;
  border-bottom: ${(props) => {
    if (props.hasError) return `1px solid ${props.theme.errorColor}`
    else return `1px solid ${props.theme.greyColor}`
  }};

  transition: border 150ms ease-out;

  outline: 0;

  &:disabled {
    background: transparent;
    border-bottom: 1px dashed ${(props) => props.theme.greyColor};
  }
`

const StyledInputContainer = styled.div`
  margin: 8px;
  display: inline-flex;
  position: relative;
  flex-direction: column;
  box-sizing: border-box;
`

const StyledInputLabel = styled.label<any>`
  font-size: ${(props) => props.theme.defaultFontSize};
  font-family: ${(props) => props.theme.fontFamily};

  color: ${(props) => {
    if (props.disabled) return props.theme.disabledColor
    else if (props.hasError) return props.theme.errorColor
    else if (props.isFocus) return props.theme[props.themeColor]
    else return props.theme.greyTextColor
  }};

  position: absolute;
  left: 0;
  transform: ${(props) => (props.isFocus || props.hasValue ? 'translate3d(0, -100%, 0);font-size: 85%;' : '')};

  pointer-events: none;

  transition: font-size 200ms, transform 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;
`

const ErrorLabel = styled.label`
  font-size: calc(${(props) => props.theme.defaultFontSize} * 0.85);
  font-family: ${(props) => props.theme.fontFamily};
  color: ${(props) => props.theme.errorColor};

  min-height: 22px;

  position: relative;
`

export const TextField = React.forwardRef<HTMLInputElement, InputProps>(({ ...props }, ref) => {
  const [isFocus, setIsFocus] = React.useState(false)
  return (
    <StyledInputContainer {...props}>
      <StyledInputLabel
        htmlFor={props.id}
        isFocus={isFocus}
        hasValue
        themeColor={props.color!}
        hasError={props.hasError}
        disabled={props.disabled}
        hidden={props.hidden}
      >
        {props.label}
      </StyledInputLabel>
      <StyledInput {...props} onFocus={() => setIsFocus(true)} ref={ref} />
      <ErrorLabel>{props.hasError && props.errorMessage}</ErrorLabel>
    </StyledInputContainer>
  )
})
